/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionnaireConfigFund
 */
export interface QuestionnaireConfigFund {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireConfigFund
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigFund
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigFund
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireConfigFund
     */
    description: string;
}

/**
 * Check if a given object implements the QuestionnaireConfigFund interface.
 */
export function instanceOfQuestionnaireConfigFund(value: object): value is QuestionnaireConfigFund {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function QuestionnaireConfigFundFromJSON(json: any): QuestionnaireConfigFund {
    return QuestionnaireConfigFundFromJSONTyped(json, false);
}

export function QuestionnaireConfigFundFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireConfigFund {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'],
    };
}

export function QuestionnaireConfigFundToJSON(json: any): QuestionnaireConfigFund {
    return QuestionnaireConfigFundToJSONTyped(json, false);
}

export function QuestionnaireConfigFundToJSONTyped(value?: QuestionnaireConfigFund | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
    };
}

